(function () {
  if (window.Pongbot26PaymentButtonSync) return;
  window.Pongbot26PaymentButtonSync = true;

  var timer = null;
  var lastVariantByForm = {};

  function closest(el, selector) {
    while (el && el.nodeType === 1) {
      if (el.matches && el.matches(selector)) return el;
      el = el.parentElement;
    }
    return null;
  }

  function sectionRoot(el) {
    return closest(el, '.shopify-section') || closest(el, '[data-section-id]') || document;
  }

  function formFor(el) {
    return closest(el, 'form[data-type="add-to-cart-form"]') || closest(el, 'form[id^="product_form_id-"]');
  }

  function setInputValue(input, variantId) {
    if (!input || !variantId) return;
    var next = String(variantId);
    input.value = next;
    input.setAttribute('value', next);
  }

  function variantIdFromForm(form) {
    if (!form) return '';
    var hidden = form.querySelector('input[name="id"][type="hidden"], input[name="id"]:not([type="radio"])');
    return hidden && hidden.value ? String(hidden.value) : '';
  }

  function variantIdFromSection(root) {
    var checked = root.querySelector('.package-selector__radio-input:checked');
    if (checked && checked.value) return String(checked.value);
    var form = root.querySelector('form[data-type="add-to-cart-form"]');
    return variantIdFromForm(form);
  }

  function variantPrice(root, variantId) {
    var sectionId = '';
    if (root.id && root.id.indexOf('shopify-section-') === 0) {
      sectionId = root.id.replace('shopify-section-', '');
    } else if (root.getAttribute) {
      sectionId = root.getAttribute('data-section-id') || '';
    }
    var script = sectionId
      ? root.querySelector('script[data-variant-json-' + sectionId + ']')
      : null;
    if (!script) {
      script = root.querySelector('script[type="application/json"]');
    }
    if (!script) return '';
    try {
      var list = JSON.parse(script.textContent || '[]');
      var match = list.find(function (v) {
        return String(v.id) === String(variantId);
      });
      if (!match || typeof match.price !== 'number') return '';
      return (match.price / 100).toFixed(2);
    } catch (e) {
      return '';
    }
  }

  function syncFormIds(root, variantId) {
    if (!variantId) return;
    root.querySelectorAll('form[data-type="add-to-cart-form"] input[name="id"]').forEach(function (input) {
      if (input.type === 'radio') return;
      setInputValue(input, variantId);
    });
    root.querySelectorAll('.package-selector__radio-input').forEach(function (input) {
      input.checked = String(input.value) === String(variantId);
    });
  }

  function syncAcceleratedAttrs(scope, variantId) {
    if (!scope || !variantId) return;
    scope.querySelectorAll('shopify-accelerated-checkout, shopify-buy-it-now-button').forEach(function (el) {
      el.setAttribute('variant-id', variantId);
      if ('variantId' in el) {
        try {
          el.variantId = variantId;
        } catch (e) {}
      }
    });
  }

  function syncPayLaterAmount(root, variantId) {
    var amount = variantPrice(root, variantId);
    if (!amount) return;
    root.querySelectorAll('[data-pp-message]').forEach(function (el) {
      el.setAttribute('data-pp-amount', amount);
    });
  }

  function initPaymentButton() {
    if (window.Shopify && typeof window.Shopify.PaymentButton === 'object' && typeof window.Shopify.PaymentButton.init === 'function') {
      window.Shopify.PaymentButton.init();
    }
  }

  function remountFromTemplate(wrap, variantId) {
    if (!wrap) return false;
    var tplId = wrap.getAttribute('data-pongbot26-payment-tpl');
    var tpl = tplId ? document.getElementById(tplId) : null;
    if (!tpl || !tpl.content) return false;
    wrap.innerHTML = '';
    wrap.appendChild(tpl.content.cloneNode(true));
    syncAcceleratedAttrs(wrap, variantId);
    return true;
  }

  function remountPaymentButtons(root, variantId) {
    var remounted = [];
    root.querySelectorAll('[data-pongbot26-payment-wrap]').forEach(function (wrap) {
      if (remountFromTemplate(wrap, variantId)) remounted.push(wrap);
    });
    root.querySelectorAll('.custom-buy-now-wrapper').forEach(function (wrap) {
      if (remounted.indexOf(wrap) !== -1) return;
      if (remountFromTemplate(wrap, variantId)) remounted.push(wrap);
    });
    initPaymentButton();
  }

  function apply(root, variantId) {
    if (!root || !variantId) return;
    var form = root.querySelector('form[data-type="add-to-cart-form"]') || formFor(root);
    var formKey = (form && form.id) || root.id || 'default';
    if (lastVariantByForm[formKey] === String(variantId)) return;
    lastVariantByForm[formKey] = String(variantId);
    syncFormIds(root, variantId);
    syncPayLaterAmount(root, variantId);
    remountPaymentButtons(root, variantId);
  }

  function schedule(root, variantId) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(function () {
      timer = null;
      apply(root || document, variantId || variantIdFromSection(root || document));
    }, 50);
  }

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || !target.matches) return;
    if (target.matches('.package-selector__radio-input, input[name="pongbot26-bundle-id"]')) {
      schedule(sectionRoot(target), target.value);
      return;
    }
    if (target.matches('form[data-type="add-to-cart-form"] input[name="id"]')) {
      schedule(sectionRoot(target), target.value);
    }
  });

  document.addEventListener('variant:change', function (event) {
    var detail = (event && event.detail) || {};
    var variantId = (detail.variant && detail.variant.id) || detail.variantId;
    if (!variantId) return;
    schedule(document, String(variantId));
  });

  document.addEventListener('custom:price:update', function (event) {
    var detail = (event && event.detail) || {};
    if (!detail.variantId) return;
    var root = document;
    if (detail.sectionId) {
      root = document.getElementById('shopify-section-' + detail.sectionId) || document;
    }
    schedule(root, String(detail.variantId));
  });

  function variantFromUrl() {
    try {
      return new URLSearchParams(window.location.search).get('variant') || '';
    } catch (e) {
      return '';
    }
  }

  function onUrlMaybeChanged() {
    var variantId = variantFromUrl();
    if (variantId) schedule(document, variantId);
  }

  window.addEventListener('popstate', onUrlMaybeChanged);

  ['pushState', 'replaceState'].forEach(function (method) {
    var original = history[method];
    if (typeof original !== 'function' || original.__pongbot26PaymentPatched) return;
    var wrapped = function () {
      var result = original.apply(this, arguments);
      onUrlMaybeChanged();
      return result;
    };
    wrapped.__pongbot26PaymentPatched = true;
    history[method] = wrapped;
  });

  document.querySelectorAll('form[data-type="add-to-cart-form"]').forEach(function (form) {
    var id = variantIdFromForm(form);
    if (id && form.id) lastVariantByForm[form.id] = String(id);
  });
})();
